module.exports = __webpack_public_path__ + "img/jssjksy_logo2.334fa6da.jpg";